export interface PostalAddress {
  street: string
  locality: string
  region: string
  postalCode: string
  country: string
  formatted: string
}

export interface SiteConfig {
  siteUrl: string
  legalName: string
  displayName: string
  phone: string
  phoneHref: string
  email: string
  address: PostalAddress
  onlinePrintShopUrl: string
}

export const siteConfig: SiteConfig = {
  siteUrl: 'https://www.packprintmail.com',
  legalName: 'Pack Print Mail LLC',
  displayName: 'Pack Print Mail',
  phone: '469-756-7680',
  phoneHref: 'tel:+14697567680',
  email: 'info@packprintmail.com',
  address: {
    street: '2761 N HWY 77, Suite 110',
    locality: 'Waxahachie',
    region: 'TX',
    postalCode: '75165',
    country: 'US',
    formatted: '2761 N HWY 77, Suite 110, Waxahachie, TX 75165',
  },
  onlinePrintShopUrl: 'https://shop.packprintmail.com/',
}
